<template>
  <button type="button" class="revitem" @click="$emit('inspect')">
    <span class="revthumb" :class="{ sig: kind === 'signature' }">
      <img v-if="thumb" :src="thumb" alt="" />
    </span>
    <span class="revinfo">
      <span class="revtop">
        <span class="revname">{{ label }}</span>
        <span class="revsub"><base-icon name="check" :width="2.6" />ثبت شد</span>
      </span>
      <span class="reveditbtn"><base-icon name="edit" />تغییر</span>
    </span>
  </button>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";

/**
 * One captured artefact on the review screen.
 *
 * Tapping the card opens a read-only preview, not a re-capture. An earlier design dropped
 * you straight into re-recording, which discarded the item before you had a proper look —
 * and most people open a card to check it, not to redo it. Re-capturing is a deliberate
 * second tap inside the preview.
 */
export default {
  name: "ReviewCard",
  components: { BaseIcon },

  props: {
    label: { type: String, required: true },
    thumb: { type: String, default: "" },
    /** "face" | "video" | "signature" — only affects how the thumbnail is fitted. */
    kind: {
      type: String,
      required: true,
      validator: (value) => ["face", "video", "signature"].indexOf(value) !== -1,
    },
  },
};
</script>

<style scoped>
.revitem {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  align-items: stretch;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  padding: 0;
  font-family: inherit;
  text-align: right;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s, border-color 0.15s;
}

.revitem:hover {
  background: var(--muted);
  border-color: var(--primary);
}

.revitem:active {
  transform: scale(0.995);
}

.revitem:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--background), 0 0 0 5px var(--ring);
}

.revthumb {
  flex: 0 0 42%;
  max-width: 172px;
  height: 100%;
  overflow: hidden;
  background: var(--muted);
  display: grid;
  place-items: center;
}

.revthumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* A signature is line art on transparency — cropping it would cut the strokes. */
.revthumb.sig img {
  object-fit: contain;
  padding: 12px;
}

.revinfo {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 18px;
}

.revtop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.revname {
  font-size: 17px;
  font-weight: 800;
  color: var(--foreground);
  line-height: 1.4;
}

.revsub {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--success);
}

.revsub >>> svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}

.reveditbtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--primary-soft);
  color: var(--primary);
  border-radius: 11px;
  padding: 8px 15px;
  font-size: 13.5px;
  font-weight: 700;
}

.reveditbtn >>> svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}
</style>
